import { useLayoutEffect, useState } from 'react'
import { getCardHeightPx, getCardWidthPx, getPerspectivePx } from '../carouselCoverflow'

/**
 * The card is measured from the carousel's own column, so there are no width
 * breakpoints: column → card → fan, depth and perspective.
 *
 * Measures before paint and follows the element with a ResizeObserver. Returns
 * null until the first measurement, which is only the first synchronous pass.
 */
export const useCarouselMetrics = (rootRef, shape, layout = 'fan') => {
  const [columnWidth, setColumnWidth] = useState(0)

  useLayoutEffect(() => {
    const element = rootRef.current
    if (!element) return undefined

    setColumnWidth(element.getBoundingClientRect().width)

    const observer = new ResizeObserver((entries) => {
      const width = entries[0]?.contentRect?.width
      if (width) setColumnWidth(width)
    })

    observer.observe(element)

    return () => observer.disconnect()
  }, [rootRef])

  if (!columnWidth) return null

  const cardW = getCardWidthPx(shape, columnWidth, layout)

  return {
    cardW,
    cardH: getCardHeightPx(shape, cardW),
    perspective: getPerspectivePx(shape, cardW),
  }
}
